import styled from 'styled-components';

import { DefaultInput } from 'assets/styled/sheets/components/Forms';

import eyeOpenIcon from 'assets/icons/password-open-eye.svg';
import eyeCloseIcon from 'assets/icons/password-close-eye.svg';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';
import { colors } from 'assets/styled/tokens';
import { cssUrl } from 'utils/cssUrl';

interface StyledInputProps {
  size?: string;
  width?: string;
  error?: boolean;
  disabled?: boolean;
}

export const StyledInput = styled.input<StyledInputProps>`
  ${DefaultInput};
  ${props => inputStyleFactory(props.size)};
  width: ${({ width }) => width};
  border-color: ${props => props.error && colors.bittersweet};
  cursor: ${props => props.disabled && 'not-allowed'};

  &:active {
    pointer-events: ${props => props.disabled && 'none'};
  }

  &::placeholder {
    color: ${props => props.disabled && colors.mediumGray};
  }

  &:focus {
    border-color: ${props => props.disabled && colors.whiteGray};
  }
`;

export const StyledIcon = styled.img`
  height: 10px;
  width: 10px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
`;

export const StyledPasswordEye = styled.div<{ isEyeOpen?: boolean }>`
  content: '';
  position: absolute;
  top: 12px;

  right: 12px;
  width: 22px;
  height: 19px;

  cursor: pointer;

  content: ${props => cssUrl(props.isEyeOpen ? eyeOpenIcon : eyeCloseIcon)};
  transition: all 300ms;
`;
